import Vue from 'vue'
import App from './App.vue'
import vuetify from '@/plugins/vuetify'
import store from '@/store'
import socketio from 'socket.io-client'
import VueSocketIO from 'vue-socket.io'
import vueCustomElement from 'vue-custom-element'

Vue.config.productionTip = false
const options = { 
  autoConnect: true,
  reconnection: true,
  transportOptions: {
      polling: {
          extraHeaders: {
              'jwt': ''
          }
      }
  }
}
export const SocketInstance = socketio(process.env.VUE_APP_WEB_SOCKET_HOST_DOMAIN /* + ':' + process.env.VUE_APP_WEB_SOCKET_HOST_PORT */, options)
Vue.use(VueSocketIO, SocketInstance)
Vue.use(vueCustomElement)
App.store = store
App.vuetify = vuetify
Vue.customElement('mpass-webchat', App, {
  shadow: true,
  beforeCreateVueInstance(root) {
    const rootNode = root.el.getRootNode();

    if (rootNode instanceof ShadowRoot) {
      root.shadowRoot = rootNode;
    } else {
      root.shadowRoot = document.head;
    }
    return root;
  }
})

// new Vue({
//   vuetify,
//   store,
//   render: h => h(App)
// }).$mount('#mpass-webchat')
